export default __webpack_public_path__ + "static/media/img-1-1200x1000.df1442cf.jpg";